import React from 'react';
import { FadeIn, Section } from './Shared';
import { Check } from 'lucide-react';
export const IncludesSection = () => {
  const items = ['Protocolo completo de 14 días paso a paso', 'Plan de drenaje hepático', 'Lista exacta de alimentos', 'Rutinas diarias simples', 'Estrategias para mantener energía estable', 'Método 80/20 para mantener resultados'];
  return <Section bg="white" data-id="element-156">
      <FadeIn data-id="element-157">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8" data-id="element-158">
          Con <span className="text-brand-teal" data-id="element-159">Hígado Vital</span> obtienes:
        </h2>
      </FadeIn>

      <div className="max-w-3xl mx-auto bg-brand-cream rounded-3xl p-6 md:p-8 shadow-sm border border-brand-teal/10" data-id="element-160">
        <div className="grid md:grid-cols-2 gap-4" data-id="element-161">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-162">
              <div className="flex items-start gap-4 bg-white p-5 rounded-xl h-full shadow-sm" data-id="element-163">
                <div className="bg-brand-teal/10 p-1.5 rounded-full mt-0.5" data-id="element-164">
                  <Check className="w-5 h-5 text-brand-teal" strokeWidth={3} data-id="element-165" />
                </div>
                <p className="text-lg text-gray-800 font-medium leading-tight pt-1" data-id="element-166">
                  {item}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </Section>;
};